module.exports = __webpack_public_path__ + "static/icons/icon-unlock--white-2addc4e8dde13d00a39e67d4b37e5c6b.svg";